import * as React from "react";
import { Container } from "react-bootstrap";
import { withTranslation, WithTranslation } from "react-i18next";
import InstituteList from "../components/InstituteList";

const InstitutePage: React.FC<WithTranslation> = ({ t }) => {
  return (
    <Container fluid={true}>
      <h1>{t("pages.institutes.title")}</h1>
      <InstituteList />
    </Container>
  );
};

export default withTranslation()(InstitutePage);
